<hatch-overlay></hatch-overlay>
<div class="general-container general-container-custom">
	<div class="main-wrapper">
		<div class="nav-container">
			<a class="back-to-search" href="javascript:void(0)" (click)="backToSearch()">{{ 'back_to_search' | translate
				}}</a>
		</div>
		<div class="heading-container">
			<h1 class="top-heading h1-like-h2">{{ 'compare' | translate }}</h1>
		</div>
	</div>
	<div class="product-main-container">
		<div class="items-container">
			<div class="item-container" *ngFor="let compareItem of productCompare; let i = index">
				<div *ngIf="compareItem" style="position: relative;">
					<div>
						<span class="remove" (click)="removeProduct(compareItem)">{{ 'remove' | translate }}</span>
					</div>
					<div class="compare-page-img-container">
						<img title="{{compareItem.productVariationName}} {{ 'graphics_cards' | translate }}"
							src="{{compareItem.imageUrl}}" alt="product image" class="compare-page-item-img"
							(load)="resizeImg($event.target, thumbnailW, thumbnailH, locale)"
							(error)="showImgError($event.target)">
					</div>
					<div class="compare-item-name h--smallest" id="cp-{{compareItem.productID}}">
						{{compareItem.productVariationName}}
					</div>


					<div #drSpinnerCont *ngIf="compareItem.digitialRiverID==='4fs|~'" class="dr-spinner-bg-grid 27">
						<div #drId class="comparepage product-row__item js-product-item" data-analytics="btn-dr-id"
							[attr.data-digital-river-id]="changeDRId(compareItem.digitialRiverID)">
							<div #priceDivCompare class="price compare-page-price js-product-price clearfix"
								style="margin-bottom: -5px;"></div>
							<div class="price compare-page-price  outside-page">
								<span>{{extractDRPriceIntegerDot(priceDivCompare, drSpinnerCont)}}</span><span
									class="decimal">{{extractDRPriceDecimal(priceDivCompare)}}</span>
							</div>
							<div class="buy-link-container cta-preorder mobile-top" (click)="transmitToCart()">
								<a class="featured-buy-link link-btn brand-green js-add-button cta-button show-out-of-stock "
									href="javascript:void(0);">
									{{ 'add_to_cart' | translate }}
								</a>

							</div>
							<div class="ship-date"></div>
						</div>
					</div>
					<div *ngIf="compareItem.digitialRiverID==='4fs|~'" class="43">
						<dr-loading-indicator [show]="drLoading"></dr-loading-indicator>
					</div>

					<div class="dr-ck-47">
						<div class="price compare-page-price h--smallest">
							<span
								*ngIf="locale === 'ru-ru'">{{compareItem.currencyCode}}{{compareItem.salePrice}}</span>
							<span
								*ngIf="locale !== 'ru-ru'">{{compareItem.currencyCode}}{{getPriceIntegerDot(compareItem.salePrice)}}</span><span
								class="decimal"
								*ngIf="locale !== 'ru-ru'">{{getPriceDecimal(compareItem.salePrice)}}</span>
						</div>
						<div class="buy-link-container clearfix">
							<!-- <span *ngIf="locale === 'en-us'" class="extra_style buy-link" style="visibility:hidden" [attr.data-mpn-code]="getEANCode(compareItem.sku)" data-color="#76b900" data-secondary-color="#fff" (click)="productName(compareItem)" >{{getBuyButtonText(locale) | translate }}</span>
							 <input *ngIf="locale !== 'en-us'" type="button" class="buy-link" value="{{getBuyButtonText(locale) | translate }}" (click)="showOverlay(compareItem)" /> -->

							<span class="extra_style buy-link  nv-buy-link" [attr.data-pid]="compareItem.productID"
								[attr.data-mpn-code]="getEANCode(compareItem.sku)" data-color="#76b900"
								data-secondary-color="#fff"
								(click)="productName(compareItem)">{{getBuyButtonText(locale) | translate }}</span>
						</div>
					</div>


					<div class="item-specs-container 62">
						<div class="top-empty-spec"></div>
						<div *ngFor="let specs of compareItem.compareProductInfo; let i=index">
							<div *ngIf="screenWidth === 'XS'" class="item-spec empty-item-spec"></div>
							<div class="item-spec" [ngStyle]="{'height.px': specs.customHeight}">{{specs.value ?
								specs.value : '--'}}
							</div>

						</div>
					</div>
				</div>
				<div *ngIf="!compareItem" style="position: relative;">
					<div>
						<a class="add-compare" href="javascript:void(0)" (click)="backToSearch()">{{ 'add' | translate
							}}</a>
					</div>
					<div class="compare-page-img-container" style="visibility: visible;">
						<div class="no-image compare-page-no-image"></div>
					</div>
					<div class="compare-item-name h--smallest">

					</div>
					<div class="price compare-page-price h--smallest">

					</div>
					<div class="buy-link-container">

					</div>
					<div *ngIf="specTitles.length" class="item-specs-container 87">
						<div class="top-empty-spec"></div>
						<div *ngFor="let specTitle of specTitles">
							<div *ngIf="screenWidth === 'XS'" class="item-spec empty-item-spec"></div>
							<div class="item-spec" [ngStyle]="{'height.px': specTitle.value}"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="specTitles.length" class="spec-titles-container">
		<div class="top-spec-title">{{ 'specs' | translate }}</div>
		<div *ngFor="let specTitle of specTitles">
			<div class="spec-title" [ngStyle]="{'height.px': specTitle.value}">{{specTitle.key | translate}}</div>
			<div *ngIf="screenWidth === 'XS'" class="spec-title empty-spec-title"></div>
		</div>
	</div>
	<div class="cover"></div>
	<div class="compare-footer">
		<footer></footer>
	</div>
</div>
<hatch-overlay [showSpinner]="retailInfoLoading$ | async" [winPageYOffset]="winPageYOffset"
	[hatchOverlayDisplay]="hatchOverlayDisplay" [retailInfo]="retailInfo$ | async"
	[productDetail]="productDetail"></hatch-overlay>